import React, { useState, useRef, useEffect } from "react";
import FontsFormStyle from "../FontsFormStyle";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";
import { SketchPicker } from "react-color";
import {
  BoxContainer,
  TitleContainer,
  ColorWrapper,
} from "./SaveSurveyButton.styled";

const SaveSurveyButton = (styleForm) => {
  const [colorPickerBackground, setColorPickerBackground] = useState(
    (styleForm &&
      styleForm.styleSaveSurveyButton &&
      styleForm.styleSaveSurveyButton.backgroundColor) || {
      r: "241",
      g: "112",
      b: "19",
      a: "1",
    }
  );

  let handleColorPicker = (item) => {
    setColorPickerBackground(item);
    let backgroundColor = `rgba(${item.r},${item.g},${item.b},${item.a})`;
    setStateSurveyConfiguration(backgroundColor, "TextButtonSave");
  };
  let btnTextHandler = () => {
    setStateSurveyConfiguration(rBtnText.current.value, "TextButtonSave");
  };

  let text =
    styleForm &&
    styleForm.styleSaveSurveyButton &&
    styleForm.styleSaveSurveyButton.text;

  const rBtnText = useRef(text);

  useEffect(() => {
    rBtnText.current.value = text;
  }, []);
  return (
    <span>
      <FontsFormStyle
        pickerId="4"
        apiKey={process.env.GOOGLE_API_KEY}
        title="TextButtonSave"
        styleFormAll={styleForm.styleSaveSurveyButton}
      />

      <BoxContainer>
        <TitleContainer>Background Color</TitleContainer>
        <ColorWrapper>
          <SketchPicker
            color={colorPickerBackground}
            onChangeComplete={(colorPickerBackground) =>
              handleColorPicker(colorPickerBackground.rgb)
            }
          />
        </ColorWrapper>
      </BoxContainer>

      <BoxContainer>
        <label>Insert text</label>
        <input
          placeholder="Insert save text"
          ref={rBtnText}
          type="text"
          // value={text}
          onChange={() => btnTextHandler()}
        />
      </BoxContainer>
    </span>
  );
};

export default SaveSurveyButton;
